import { TranslatePipe } from '../../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../../../services/core-rest.service';
import AngularHelperService from '../../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-give-consents',
	templateUrl: './modal-give-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalGiveConsentsComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalGiveConsentsComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.processing = false;
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleModalSubmit = this.handleModalSubmit;
	}
	
	handleModalInit() {
		this.vm.user = {};
		this.vm.user.personalCode = this.angularHelperService.copy(this.vm.userEstonianIdentificationCode) || {}
	}
	
	handleModalSubmit() {
		if (this.vm.processing) {
			return;
		}
		
		this.vm.processing = true;
		this.restService.updateConsentsPreVisitRecordForPatientPatientGivesConsentsForPreVisit(this.vm.user).then(
			(response) => {
				this.dialogRef.close(response)
			},
			(error) => {
				console.error('Failed updating user consents', error);
				if (error.error.errorCode === 'INSURANCE_INFO_NOT_FOUND') {
					alert(this.angularFilterHelperService.translate('PreVisit.Record_Ticket_For_Person.Consents_Not_Given'));
				}
				this.vm.processing = false;
			}
		);
	}
	
	handleModalClose() {
		this.dialogRef.close();
	}
	
}